import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/contexts';
import { useHttp } from 'src/hooks';

const FacebookCallback = () => {
  const navigate = useNavigate();
  const { sendRequest } = useHttp();
  const { fetchProfile } = useContext(AuthContext);
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const fetchFacebookUser = () => {
    sendRequest(
      {
        url: `facebook/callback?code=${code}&state=${state}`,
        method: 'GET',
      },
      (data: any) => {
        fetchProfile();
        window.location.href = '/dashboard/account-setup?step=2';
      },
    );
  };

  useEffect(() => {
    fetchFacebookUser();
  }, []);
  return <div></div>;
};

export default FacebookCallback;
